import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SchemaJSONLDProps {
  data: object | object[];
}

export const SchemaJSONLD: React.FC<SchemaJSONLDProps> = ({ data }) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data)}
      </script>
    </Helmet>
  );
};
